"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertObjectPropertyToGetterAndSetterName = void 0;
var convertObjectPropertyToGetterAndSetterName = function (propertyKey) {
    var uppercaseInitialPropertyLetter = propertyKey.charAt(0).toUpperCase();
    var restOfPropertyLetters = propertyKey.slice(1);
    var propertyKeyInPascalCase = "".concat(uppercaseInitialPropertyLetter).concat(restOfPropertyLetters);
    var getterMethodName = "get".concat(propertyKeyInPascalCase);
    var setterMethodName = "set".concat(propertyKeyInPascalCase);
    return {
        getterMethodName: getterMethodName,
        setterMethodName: setterMethodName,
    };
};
exports.convertObjectPropertyToGetterAndSetterName = convertObjectPropertyToGetterAndSetterName;
